enum StorageType {
  AuthData = 'auth-data',
  CurrentCommerce = 'current-commerce',
  CurrentVenue = 'current-venue',
}

export default StorageType;
